import { strftime } from '../classes/Const';
import { convertDCLCode, createDateBeginningDay } from '../store';

const createDateFromCode = (code) => {
	//DLCCodeにも対応
	let hours = Number(String(code).substr(8, 2));
	let date = new Date(String(code).substr(0, 4) + '/' + String(code).substr(4, 2) + '/' + String(code).substr(6, 2) + ' 00:' + String(code).substr(10, 2));
	date.setHours(date.getHours() + hours);
	return date;
};

const createDateYmdFromCode = (code) => {
	return new Date(String(code).substr(0, 4) + '/' + String(code).substr(4, 2) + '/' + String(code).substr(6, 2));
};

const createTickCodeFromDate = (date) => {
	return strftime('%Y%m%d%H%M', date);
};

const _strftime = (format, code) => {
	//%Y,%m,%d,%H,%M,%Aに対応
	let dateYmd = createDateYmdFromCode(code);
	let YYYY = String(code).substr(0, 4);
	let mm = String(code).substr(4, 2);
	let dd = String(code).substr(6, 2);
	let HH = String(code).substr(8, 2);
	let MM = String(code).substr(10, 2);
	let A = strftime('%A', dateYmd);
	let text = format.replace('%Y', YYYY).replace('%m', mm).replace('%d', dd).replace('%H', HH).replace('%M', MM).replace('%A', A);
	return text;
}
export default class ScheduleTick {
	
	get asDate() {
		let date = createDateFromCode(this.code);
		return date;
	}
	get asDateYmd () {
		let date = createDateYmdFromCode(this.code);
		return date;
	}
	get asMinutes() {
		let date = this.asDate;
		return date.getHours() * 60 + date.getMinutes()
	}
	get asYmd() {
		return this.strftime('%Y%m%d');
	}
	get asmd() {
		return this.strftime('%m%d');
	}
	get asYmdHM() {
		return this.strftime('%Y%m%d%H%M');
	}
	get asHM() {
		return this.strftime('%H%M');
	}
	get asDCLCode() {
		return convertDCLCode(this.asDate);
	}
	get asFormattedHM() {
		return this.strftimeDCL('%H:%M');
	}

	constructor(params) {
		this.code = createTickCodeFromDate(createDateFromCode(params.code));
	}

	strftime(format) {
		let text = _strftime(format, this.code);
		return text;
	}
	strftimeDCL(format) {
		let text = _strftime(format, this.asDCLCode);
		return text;
	}
	addMinutes(minutes) {
		let date = this.asDate;
		date.setMinutes(date.getMinutes() + minutes);
		
		this.code = createTickCodeFromDate(date);
		return this;
	}
	addHours(hours) {
		let date = this.asDate;
		date.setHours(date.getHours() + hours);

		this.code = createTickCodeFromDate(date);
		return this;
	}
	addDays(days) {
		let date = this.asDate;
		date.setDate(date.getDate() + days);
		
		this.code = createTickCodeFromDate(date);
		return this;
	}
	static createTickFromDate(date) {
		return new ScheduleTick({
			code: createTickCodeFromDate(date),
		});
	}
	equalDCLYmd(other) {
		return this.strftimeDCL('%Y%m%d') === other.strftimeDCL('%Y%m%d');
	}
	clone() {
		return new ScheduleTick({
			code: this.code,
		});
	}
	isFirstTick(date) {
		let source_day = createDateBeginningDay(date);
		let souse_ymdhm = ScheduleTick.createTickFromDate(source_day).asYmdHM;
		return (this.asYmdHM == souse_ymdhm);
	}
	isBeforeDay(date) {
		let source_day = createDateBeginningDay(date);
		let souse_ymdhm = ScheduleTick.createTickFromDate(source_day).asYmdHM;
		return (this.asYmdHM < souse_ymdhm);
	}
	isAfterDay(date) {
		let source_day = createDateBeginningDay(date);
		source_day.setHours(source_day.getHours() + 24);
		let souse_ymdhm = ScheduleTick.createTickFromDate(source_day).asYmdHM;
		return (this.asYmdHM > souse_ymdhm);
	}
	getDiffFromDateAsMinutes(date) {
		return (this.asDate.getTime() - date.getTime()) / 1000 / 60;
	}
}
